<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="wrapper">
      <div class="title-screen">
        <span>{{ adminText('workflowsAll.edit_message_96116a5', 'Edit message') }}</span>
      </div>
      <text-field v-model="form.title" :label="adminText('workflowsAll.title_768e0c1', 'Title')" autofocus :validator="$v.form.title" />
      <textarea-field
        v-model="form.message"
        :label="adminText('workflowsAll.message_68f4145', 'Message')"
        height="300"
        :validator="$v.form.message"
      />
      <div class="button-container">
        <main-button :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')" color="red" @click="$emit('delete', initialValue.id)" />
        <div>
          <main-button :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')" flat outline @click="$emit('cancel')" />
          <main-button :text="adminText('workflowsAll.save_efc007a', 'Save')" @click="updateMessage()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import Spinner from '../shared/spinner.vue'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'message-to-attendee-container',
  components: {
    Spinner,
  },
  props: {
    initialValue: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      form: this.initialValue,
    }
  },
  validations() {
    return {
      form: {
        title: { required },
        message: { required },
      },
    }
  },
  methods: {
    async updateMessage() {
      await submitGuard(this, async () => {
        const data = this.form
        data.id = Number(data.id)
        this.$emit('update', data)
      })
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
  .wrapper {
    margin-top: 1.5rem;
  }
}
.wrapper {
  max-width: 42.5rem;
}
.button-container {
  display: flex;
  justify-content: space-between;
}
.message-style {
  height: 200px;
}
</style>
